import { useReducedMotion } from '@/hooks/useReducedMotion';
import { useDialogueStore } from '@/state/dialogueStore';
import { selectDialogueLine, selectPendingAdvance } from '@/state/selectors';
import styles from './DialogueBox.module.css';
import { useTypewriter } from './useTypewriter';

export function DialogueBox() {
  const line = useDialogueStore(selectDialogueLine);
  const pendingAdvance = useDialogueStore(selectPendingAdvance);
  const reduced = useReducedMotion();
  const { displayed, isDone, revealAll } = useTypewriter({ text: line, reduced });

  const visible = line != null && line.length > 0;
  const canAdvance = visible && isDone && pendingAdvance;

  return (
    <div
      className={styles.box}
      data-testid="dialogue-box"
      data-visible={visible ? 'true' : 'false'}
      data-done={isDone ? 'true' : 'false'}
      data-can-advance={canAdvance ? 'true' : 'false'}
      data-skippable={visible && !isDone ? 'true' : 'false'}
      role={visible && !isDone ? 'button' : undefined}
      tabIndex={visible && !isDone ? 0 : undefined}
      aria-label={visible && !isDone ? 'Reveal full dialogue' : undefined}
      onClick={visible && !isDone ? revealAll : undefined}
      onKeyDown={
        visible && !isDone
          ? (event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              event.preventDefault();
              revealAll();
            }
          : undefined
      }
      {...(visible ? {} : { 'aria-hidden': 'true' })}
    >
      <span className={styles.text} data-testid="dialogue-text" role="status" aria-live="polite">
        {displayed}
      </span>
      {canAdvance ? (
        <button
          type="button"
          className={styles.advance}
          data-testid="dialogue-advance"
          onClick={() => {
            useDialogueStore.getState().confirmAdvance();
          }}
          aria-label="Continue"
        >
          <span aria-hidden="true">▸</span>
        </button>
      ) : visible ? (
        <span
          className={styles.caret}
          data-testid="dialogue-caret"
          data-done={isDone ? 'true' : 'false'}
          aria-hidden="true"
        />
      ) : null}
    </div>
  );
}
